import './Index.css';
import Menu from "./Menu";
import { Outlet } from 'react-router-dom';
import Header from '../Layout/Header';

function Index() {
  return (
    <>
      <Header fixed={true} />
      <Menu />
      <div className='api_content'>
        <Outlet></Outlet>
      </div>
    </>
  );
}

export default Index;
